import {
  COFFEE_GET_MATCH_REQUESTING,
  COFFEE_GET_MATCH_SUCCESS,
  COFFEE_GET_MATCH_ERROR,
} from "./constants";

import { LOGOUT } from "../login/constants";

const INITIAL_STATE = {
  match: [],
  requesting: false,
  matchId: 0,
  activated: false,
  error: "",
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case COFFEE_GET_MATCH_REQUESTING:
      return {
        ...state,
        requesting: true,
        error: "",
      };

    case COFFEE_GET_MATCH_SUCCESS:
      return {
        ...state,
        match: action.payload.pair,
        matchId: action.payload.id,
        activated: action.payload.activated,
        error: "",
        requesting: false,
      };

    case COFFEE_GET_MATCH_ERROR:
      return {
        ...state,
        error: action.payload.message,
        requesting: false,
      };

    case LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
};
